import { registerSW } from "virtual:pwa-register";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { ToastProvider } from "./components/ui/ToastProvider";
import { ThemeProvider } from "./design-system/ThemeProvider";
import "./index.css";

if ("serviceWorker" in navigator) {
  registerSW({
    onOfflineReady() {
      console.log("PWA: offline ready");
    },
  });
}

const container = document.getElementById("root");
if (container === null) {
  throw new Error("#root element not found");
}

// 簡易確認用 read-only UI のため、stale-while-revalidate 寄り。
// 細かい優先順位調整は Phase 2-3c 以降で必要になったら見直す。
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30 秒は再フェッチしない
      gcTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
